export enum GoCoordinatesType {
    ASR = 'ASR',
    LatitudeLongitude = 'LatitudeLongitude',
    Map = 'Map',
}

export const GoCoordinatesTypeToLabelMapping = {
    [GoCoordinatesType.ASR]: 'ASR',
    [GoCoordinatesType.LatitudeLongitude]: 'Lat/Long',
    [GoCoordinatesType.Map]: 'Map',
};
